import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-admin-pd-approve',
  templateUrl: './admin-pd-approve.component.html',
  styleUrls: ['./admin-pd-approve.component.css']
})
export class AdminPdApproveComponent implements OnInit {
	
  tabName = "";
  respObject: any;
  respObject1: any;
  respObject2: any;
  respObject3: any;
  respObject5: any;
  loaderVisibility: boolean = false;

  monthWiseData = [];
  monthCheck: any = {};

  qtr1WiseData = [];
  qtr1Check: any = {};

  qtr2WiseData = [];
  qtr2Check: any = {};

  qtr3WiseData = [];
  qtr3Check: any = {};

  qtr5WiseData = [];
  qtr5Check: any = {};

  respConfig: any;
  configData: any;
  configVal="";
  
  constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService) { }
  

  ngOnInit(){
    this.loaderVisibility=true;
    this.changeTab('Segment');
  	/*this.tabName = 'Segment';
  	
  		this.genMonthWiseData();
  	
  		this.genQtr1WiseData();
  	
  		this.genQtr2WiseData();
  	
  		this.genQtr3WiseData();
  	
  		this.genQtr5WiseData();
  	*/
  	const data = {"configType":"PD_NOTE"};
  	this.configVal = "";
    this._rest.getSettingsData(data).subscribe((res) => {
      this.respConfig = res;
    	if(this.respConfig.error==0){ 
        if(this.respConfig.resp.length>0){
    		  this.configData = this.respConfig.resp[0];
    			this.configVal=this.respConfig.resp[0].KeyValue;
    		} else {
    			this.configData = {};
    		}
    	} 
      this.loaderVisibility=false;  
    });
  }

  changeTab(tab){
  	this.tabName = tab;
  	if(tab=="Segment"){
  		this.genMonthWiseData();
  	} else if(tab=="Form 1"){
  		this.genQtr1WiseData();
  	} else if(tab=="Form 2"){
  		this.genQtr2WiseData();
  	} else if(tab=="Form 3"){
  		this.genQtr3WiseData();
  	} else if(tab=="Form 5"){
  		this.genQtr5WiseData();
  	}
  }

  updateConfig(){
    this.loaderVisibility=true;
    const data = {"keyIndex":"PD_NOTE", "keyValue":this.configVal};
    console.log(data);
    this._rest.updateSettingsData(data).subscribe((res) => {
		  alert("Public Dashboard Note Added successfully.");
      this.loaderVisibility=false;
    });
  }

  genMonthWiseData(){
    this.loaderVisibility=true;
  	var req = {};
  	this.monthWiseData = [];
  	this._rest.getSegmentPdUnapproveData(req).subscribe((res) => {
  		this.respObject = res;
  		if(this.respObject.error==0){
  			if(this.respObject.resp.length>0){
  				for(let i=0;i<this.respObject.resp.length;i++){
  					this.monthWiseData.push(this.respObject.resp[i]);
  				}
  			}
  		}
      this.loaderVisibility=false;
  	});
  }

  genQtr1WiseData(){
    this.loaderVisibility=true;
  	var req1 = {"formType":"Form 1"};
  	this.qtr1WiseData = [];
  	this._rest.getFormPdUnapproveData(req1).subscribe((res) => {
  		this.respObject1 = res;
  		//console.log(res);
  		if(this.respObject1.error==0){
  			if(this.respObject1.resp.length>0){
  				for(let i=0;i<this.respObject1.resp.length;i++){
  					this.qtr1WiseData.push(this.respObject1.resp[i]);
  				}
  			}
  		}
      this.loaderVisibility=false;
  	});
  }

  genQtr2WiseData(){
    this.loaderVisibility=true;
  	var req2 = {"formType":"Form 2"};
  	this.qtr2WiseData = [];
  	this._rest.getFormPdUnapproveData(req2).subscribe((res) => {
  		this.respObject2 = res;
  		//console.log(res);
  		if(this.respObject2.error==0){
  			if(this.respObject2.resp.length>0){
  				for(let i=0;i<this.respObject2.resp.length;i++){
  					this.qtr2WiseData.push(this.respObject2.resp[i]);
  				}
  			}
  		}
      this.loaderVisibility=false;
  	});
  }

  genQtr3WiseData(){
    this.loaderVisibility=true;
  	var req3 = {"formType":"Form 3"};
  	this.qtr3WiseData = [];
  	this._rest.getFormPdUnapproveData(req3).subscribe((res) => {
  		this.respObject3 = res;
  		//console.log(res);
  		if(this.respObject3.error==0){
  			if(this.respObject3.resp.length>0){
  				for(let i=0;i<this.respObject3.resp.length;i++){
  					this.qtr3WiseData.push(this.respObject3.resp[i]);
  				}
  				//console.log(this.qtr3WiseData);
  			}
  		}
      this.loaderVisibility=false;
  	});
  }

  genQtr5WiseData(){
    this.loaderVisibility=true;
  	var req5 = {"formType":"Form 5"};
  	this.qtr5WiseData = [];
  	this._rest.getFormPdUnapproveData(req5).subscribe((res) => {
  		this.respObject5 = res;
  		//console.log(res);
  		if(this.respObject5.error==0){
  			if(this.respObject5.resp.length>0){
  				for(let i=0;i<this.respObject5.resp.length;i++){
  					this.qtr5WiseData.push(this.respObject5.resp[i]);
  				}
  			}
  		}
      this.loaderVisibility=false;
  	});
  }

  getMonthCheckVal(){
    this.loaderVisibility=true;
  	let selecteds = Object.keys(this.monthCheck).filter((item, index) => {
        return this.monthCheck[item];
    });
    if(selecteds.length>0){
    		let uReq = {"id":selecteds};
    		this._rest.approveSegmentPdData(uReq).subscribe((res) => {
    			this.genMonthWiseData();
          //this.loaderVisibility=false;
    		});
    }
  }

  getQtr1CheckVal(){
    this.loaderVisibility=true;
  	let selecteds = Object.keys(this.qtr1Check).filter((item, index) => {
        return this.qtr1Check[item];
    });
    if(selecteds.length>0){
		let uReq = {"id":selecteds, "formType":"Form 1"};
		this._rest.approveFormPdData(uReq).subscribe((res) => {
			this.genQtr1WiseData();
      //this.loaderVisibility=false;
		});
    	
    }
  }

  getQtr2CheckVal(){
    this.loaderVisibility=true;
  	let selecteds = Object.keys(this.qtr2Check).filter((item, index) => {
        return this.qtr2Check[item];
    });
    if(selecteds.length>0){    	
		let uReq = {"id":selecteds, "formType":"Form 2"};
		this._rest.approveFormPdData(uReq).subscribe((res) => {
			this.genQtr2WiseData();
      //this.loaderVisibility=false;
		});    	
    }
  }

  getQtr3CheckVal(){
    this.loaderVisibility=true;
  	let selecteds = Object.keys(this.qtr3Check).filter((item, index) => {
        return this.qtr3Check[item];
    });
    if(selecteds.length>0){
		let uReq = {"id":selecteds, "formType":"Form 3"};
		this._rest.approveFormPdData(uReq).subscribe((res) => {
			this.genQtr3WiseData();
      //this.loaderVisibility=false;
		});
    }
  }

  getQtr5CheckVal(){
    this.loaderVisibility=true;
  	let selecteds = Object.keys(this.qtr5Check).filter((item, index) => {
        return this.qtr5Check[item];
    });
    if(selecteds.length>0){
    		let uReq = {"id":selecteds, "formType":"Form 5"};
    		this._rest.approveFormPdData(uReq).subscribe((res) => {
    			this.genQtr5WiseData();
         // this.loaderVisibility=false;
    		});
    }
  }

  selectUnselectMonth(evt){
  	//console.log(evt);
  	if(this.monthWiseData.length>0){
  		for(let i=0;i<this.monthWiseData.length;i++){
  			if(evt.target.checked==true){
  				this.monthCheck[this.monthWiseData[i].id]=true;
  			} else {
  				this.monthCheck[this.monthWiseData[i].id]=false;
  			}  			
  		}
  	}
  }

  selectUnselectQtr1(evt){
  	if(this.qtr1WiseData.length>0){
  		for(let i=0;i<this.qtr1WiseData.length;i++){
  			if(evt.target.checked==true){
  				this.qtr1Check[this.qtr1WiseData[i].id]=true;
  			} else {
  				this.qtr1Check[this.qtr1WiseData[i].id]=false;
  			}  			
  		}
  	}
  }

  selectUnselectQtr2(evt){
  	if(this.qtr2WiseData.length>0){
  		for(let i=0;i<this.qtr2WiseData.length;i++){
  			if(evt.target.checked==true){
  				this.qtr2Check[this.qtr2WiseData[i].id]=true;
  			} else {
  				this.qtr2Check[this.qtr2WiseData[i].id]=false;
  			}  			
  		}
  	}
  }

  selectUnselectQtr3(evt){
  	if(this.qtr3WiseData.length>0){
  		for(let i=0;i<this.qtr3WiseData.length;i++){
  			if(evt.target.checked==true){
  				this.qtr3Check[this.qtr3WiseData[i].id]=true;
  			} else {
  				this.qtr3Check[this.qtr3WiseData[i].id]=false;
  			}  			
  		}
  	}
  }

  selectUnselectQtr5(evt){
  	if(this.qtr5WiseData.length>0){
  		for(let i=0;i<this.qtr5WiseData.length;i++){
  			if(evt.target.checked==true){
  				this.qtr5Check[this.qtr5WiseData[i].id]=true;
  			} else {
  				this.qtr5Check[this.qtr5WiseData[i].id]=false;
  			}  			
  		}
  	}
  }

}
